/* Sales store only: the free calculators on their own pages (/pages/<tool>-calculator, section sales-tool-page).
   Same fields and maths as the landing page's #tools pages (assets/sales-landing.js, FREE TOOLS), so both agree. */
(function () {
  var TOOLS = {
    profit: {
      fields: [
        { k: 'price', l: 'Selling price', p: '$', v: 39 },
        { k: 'cost', l: 'Product cost', p: '$', v: 9 },
        { k: 'ship', l: 'Shipping cost', p: '$', v: 4 },
        { k: 'fee', l: 'Payment fee', s: '%', v: 2.9 },
        { k: 'ad', l: 'Ad cost per order', p: '$', v: 12 },
        { k: 'other', l: 'Other costs per order', p: '$', v: 2 },
        { k: 'fixed', l: 'Monthly overhead', p: '$', v: 300 },
        { k: 'orders', l: 'Orders per month', v: 200 }
      ],
      calc: function (v) {
        var fee = v.price * v.fee / 100;
        var gross = v.price - v.cost - v.ship - fee - v.other;
        var profit = gross - v.ad;
        var margin = v.price > 0 ? profit / v.price * 100 : 0;
        var gmargin = v.price > 0 ? gross / v.price * 100 : 0;
        var net = profit * v.orders - v.fixed;
        return {
          hero: { label: 'Profit per order', value: money(profit), note: pct(margin) + ' net margin' },
          rows: [
            { l: 'Gross margin (before ads)', v: pct(gmargin), cls: gross > 0 ? 'good' : 'warn' },
            { l: 'Revenue per month', v: money(v.price * v.orders) },
            { l: 'Product and shipping', v: '-' + money((v.cost + v.ship) * v.orders) },
            { l: 'Payment fees', v: '-' + money(fee * v.orders) },
            { l: 'Ad spend', v: '-' + money(v.ad * v.orders) },
            { l: 'Other costs', v: '-' + money(v.other * v.orders + v.fixed) },
            { l: 'Profit per month', v: money(net), cls: net > 0 ? 'good' : 'warn' }
          ]
        };
      }
    },
    roas: {
      fields: [
        { k: 'price', l: 'Selling price', p: '$', v: 39 },
        { k: 'cost', l: 'Product cost', p: '$', v: 9 },
        { k: 'ship', l: 'Shipping cost', p: '$', v: 4 },
        { k: 'fee', l: 'Payment fee', s: '%', v: 2.9 },
        { k: 'other', l: 'Other costs per order', p: '$', v: 2 },
        { k: 'target', l: 'Target profit per order', p: '$', v: 8 }
      ],
      calc: function (v) {
        var fee = v.price * v.fee / 100;
        var gross = v.price - v.cost - v.ship - fee - v.other;
        var beRoas = gross > 0 ? v.price / gross : 0;
        var tgtCpa = gross - v.target;
        var tgtRoas = tgtCpa > 0 ? v.price / tgtCpa : 0;
        var at3 = gross - v.price / 3;
        return {
          hero: { label: 'Break-even ROAS', value: gross > 0 ? beRoas.toFixed(2) + 'x' : 'n/a', note: gross > 0 ? 'Below this you lose money' : 'Gross profit is zero or negative' },
          rows: [
            { l: 'Gross profit per order', v: money(gross), cls: gross > 0 ? 'good' : 'warn' },
            { l: 'Break-even cost per order', v: money(gross) },
            { l: 'Max cost per order at target', v: money(tgtCpa), cls: tgtCpa > 0 ? '' : 'warn' },
            { l: 'ROAS needed for target', v: tgtRoas > 0 ? tgtRoas.toFixed(2) + 'x' : 'not reachable' },
            { l: 'Profit at 3x ROAS', v: money(at3), cls: at3 > 0 ? 'good' : 'warn' }
          ]
        };
      }
    },
    subs: {
      fields: [
        { k: 'price', l: 'Subscription price', p: '$', s: '/mo', v: 39 },
        { k: 'subs', l: 'Active subscribers', v: 250 },
        { k: 'churn', l: 'Monthly churn', s: '%', v: 8 },
        { k: 'margin', l: 'Gross margin', s: '%', v: 60 },
        { k: 'other', l: 'Other costs per shipment', p: '$', v: 3 },
        { k: 'newsubs', l: 'New subscribers a month', v: 60 }
      ],
      calc: function (v) {
        var mrr = v.price * v.subs;
        var life = v.churn > 0 ? 100 / v.churn : 0;
        var perCycle = v.price * v.margin / 100 - v.other;
        var ltv = perCycle * life;
        var lost = v.subs * v.churn / 100;
        var net = v.newsubs - lost;
        return {
          hero: { label: 'Monthly recurring revenue', value: money(mrr), note: money(mrr * 12) + ' a year at today’s count' },
          rows: [
            { l: 'Gross profit per shipment', v: money(perCycle), cls: perCycle > 0 ? 'good' : 'warn' },
            { l: 'Average subscriber lifetime', v: life ? life.toFixed(1) + ' months' : 'n/a' },
            { l: 'Lifetime value per subscriber', v: money(ltv) },
            { l: 'Subscribers lost a month', v: Math.round(lost).toLocaleString('en-US') },
            { l: 'Net growth a month', v: (net >= 0 ? '+' : '') + Math.round(net).toLocaleString('en-US'), cls: net > 0 ? 'good' : 'warn' }
          ]
        };
      }
    },
    roi: {
      fields: [
        { k: 'spend', l: 'Amount spent', p: '$', v: 350 },
        { k: 'gain', l: 'Revenue it produced', p: '$', v: 1400 },
        { k: 'margin', l: 'Gross margin on that revenue', s: '%', v: 60 },
        { k: 'other', l: 'Other costs', p: '$', s: '/mo', v: 0 },
        { k: 'months', l: 'Over how many months', v: 12 }
      ],
      calc: function (v) {
        var profit = v.gain * v.margin / 100;
        var total = v.spend + v.other * v.months;
        var net = profit - total;
        var roi = total > 0 ? net / total * 100 : 0;
        var per = v.months > 0 ? net / v.months : 0;
        var back = profit > 0 && v.months > 0 ? Math.ceil(total / (profit / v.months)) : 0;
        return {
          hero: { label: 'Return on investment', value: pct(roi), note: net >= 0 ? money(net) + ' net profit' : money(net) + ' net loss' },
          rows: [
            { l: 'Gross profit produced', v: money(profit) },
            { l: 'Total cost', v: '-' + money(total) },
            { l: 'Net result', v: money(net), cls: net > 0 ? 'good' : 'warn' },
            { l: 'Per month', v: money(per) },
            { l: 'Money back after', v: back ? back + (back === 1 ? ' month' : ' months') : 'n/a' }
          ]
        };
      }
    },
    ltv: {
      fields: [
        { k: 'aov', l: 'Average order value', p: '$', v: 56 },
        { k: 'freq', l: 'Orders per year', v: 2.5 },
        { k: 'years', l: 'Years they stay', v: 2 },
        { k: 'margin', l: 'Gross margin', s: '%', v: 60 },
        { k: 'other', l: 'Other costs per order', p: '$', v: 3 },
        { k: 'keep', l: 'Profit share you keep', s: '%', v: 40 }
      ],
      calc: function (v) {
        var perOrder = v.aov * v.margin / 100 - v.other;
        var orders = v.freq * v.years;
        var ltv = perOrder * orders;
        var maxCac = ltv * (1 - v.keep / 100);
        return {
          hero: { label: 'Lifetime value', value: money(ltv), note: orders.toFixed(1) + ' orders over ' + v.years + (v.years === 1 ? ' year' : ' years') },
          rows: [
            { l: 'Gross profit per order', v: money(perOrder), cls: perOrder > 0 ? 'good' : 'warn' },
            { l: 'First order value', v: money(perOrder) },
            { l: 'Repeat value after the first', v: money(ltv - perOrder) },
            { l: 'Max you can pay per customer', v: money(maxCac), cls: 'good' },
            { l: 'Profit kept per customer', v: money(ltv - maxCac) }
          ]
        };
      }
    }
  };

  function money(n) {
    if (!isFinite(n)) return 'n/a';
    var neg = n < 0, a = Math.abs(n);
    var s = a >= 1000 ? Math.round(a).toLocaleString('en-US') : (Math.round(a * 100) / 100).toLocaleString('en-US', { minimumFractionDigits: a % 1 ? 2 : 0, maximumFractionDigits: 2 });
    return (neg ? '-$' : '$') + s;
  }
  function pct(n) { return (isFinite(n) ? (Math.round(n * 10) / 10).toLocaleString('en-US') : '0') + '%'; }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  document.querySelectorAll('[data-pb-tool]').forEach(function (root) {
    var t = TOOLS[root.getAttribute('data-pb-tool')];
    if (!t) return;
    var form = root.querySelector('.pt-form'), out = root.querySelector('.pt-out');
    var id = root.id || 'pt';
    form.innerHTML = t.fields.map(function (f) {
      return '<div class="pt-f"><label for="' + id + '-' + f.k + '">' + esc(f.l) + '</label><div class="pt-in">'
        + (f.p ? '<span>' + f.p + '</span>' : '')
        + '<input id="' + id + '-' + f.k + '" data-k="' + f.k + '" type="number" inputmode="decimal" step="any" min="0" value="' + f.v + '">'
        + (f.s ? '<em>' + f.s + '</em>' : '') + '</div></div>';
    }).join('');
    function run() {
      var v = {};
      t.fields.forEach(function (f) {
        var el = form.querySelector('[data-k="' + f.k + '"]');
        var n = parseFloat(el && el.value);
        v[f.k] = isFinite(n) ? n : 0;
      });
      var r = t.calc(v);
      out.innerHTML = '<div class="pt-hero"><em>' + esc(r.hero.label) + '</em><b>' + esc(r.hero.value) + '</b><i>' + esc(r.hero.note) + '</i></div>'
        + '<div class="pt-rows">' + r.rows.map(function (row) {
          return '<div class="pt-r' + (row.cls ? ' ' + row.cls : '') + '"><span>' + esc(row.l) + '</span><b>' + esc(row.v) + '</b></div>';
        }).join('') + '</div>';
    }
    form.addEventListener('input', run);
    form.addEventListener('submit', function (e) { e.preventDefault(); });
    run();
  });
})();
